import { render, staticRenderFns } from "./UserTab.vue?vue&type=template&id=5db0a73c&scoped=true"
import script from "./UserTab.vue?vue&type=script&lang=js"
export * from "./UserTab.vue?vue&type=script&lang=js"
import style0 from "./UserTab.vue?vue&type=style&index=0&id=5db0a73c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db0a73c",
  null
  
)

export default component.exports